// extracted by mini-css-extract-plugin
module.exports = {"alert":"Home_alert__15oDU","alertTitle":"Home_alertTitle__3MZ8R","alertMessage":"Home_alertMessage__iVHB_","alertButton":"Home_alertButton__3ada1","spacer":"Home_spacer__3VgSJ"};